// Plain stack for canvas, which can't resolve CSS variables.
export const FONT_FAMILY_STACK =
  '"Aktiv Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
// Through the token so font-legacy.css (hsds-tokens) can swap it per company.
export const FONT_FAMILY = `var(--hsds-token-font-family, ${FONT_FAMILY_STACK})`
export const FONT_FAMILY_MONO =
  '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
// Scoutie's ss07 (single-storey "g") for small/UI text. The styleset name is
// declared via @font-feature-values in GlobalStyle, which scopes it to Scoutie.
export const SMALL_TEXT_FONT_VARIANT_ALTERNATES = 'styleset(single-storey-g)'
export const FONT_SIZE = 13
export const GLOBAL_FONT_SIZE_NAMESPACE = '--hsds-global-font-size'
export const BASE_FONT_SIZE = FONT_SIZE
export const defaultProps = {
  baseFontSize: BASE_FONT_SIZE,
  fontSize: BASE_FONT_SIZE,
}
